export default __webpack_public_path__ + "static/media/benefits.8074497b.png";